
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LOGO } from '../constants';

const Navbar: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'py-3 sm:py-4 glass-card border-b border-white/5' : 'py-6 sm:py-8 bg-transparent'}`}>
      <div className="container mx-auto px-4 sm:px-6 flex items-center justify-between">
        <Link to="/" className="flex items-center group">
          <div className="h-10 md:h-16 w-auto transition-transform duration-500 group-hover:scale-105">
            <LOGO className="h-full w-auto" hideText={false} />
          </div>
        </Link>
        
        <div className="flex items-center space-x-4 md:space-x-10">
          <div className="hidden md:flex items-center space-x-10">
            <Link to="/solutions" className={`mono text-[10px] font-bold transition-colors tracking-widest uppercase ${location.pathname === '/solutions' ? 'text-[#32dee6]' : 'text-gray-400 hover:text-white'}`}>/Solutions</Link>
            <Link to="/process" className={`mono text-[10px] font-bold transition-colors tracking-widest uppercase ${location.pathname === '/process' ? 'text-[#32dee6]' : 'text-gray-400 hover:text-white'}`}>/Process</Link>
          </div>
          <Link 
            to="/contact" 
            className="px-4 py-2.5 sm:px-8 sm:py-3.5 bg-[#1d3fc4] text-white mono text-[9px] sm:text-[10px] font-bold rounded-xl hover:bg-[#32dee6] hover:text-black transition-all transform hover:-translate-y-0.5 tracking-widest uppercase shadow-lg shadow-blue-900/20"
          >
            Deploy
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;